// Contact.js
import React from 'react';

const Contact = () => {
  return (
    <div className='contact-container'>
      <div className='contact-card'>
        <div className='contact-content'>
          <div className='contact-links'>
            <div>
              <a
                href='https://www.youtube.com/@thisisaworkoffiction'
                className='contact-links'
              >
                YouTube
              </a>
            </div>

            <div className='address'>
              <span>Sera WoF</span>
              <span>98 US Hwy 46</span>
              <span>Ste 7 #2007</span>
              <span>Budd Lake, NJ 07828</span>
              <span>United States</span>
            </div>

            <div>
              <a
                href='mailto:serafina@thisisaworkoffiction.com'
                className='contact-links'
              >
                serafina@thisisaworkoffiction.com
              </a>
            </div>

            <div className='back-link-container'>
              <a href='/' className='back-link'>
                ← Videos
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
